import { Injectable } from '@angular/core';
import { Currencies } from 'src/app/models/Configurations/Currencies';
import { Languages } from 'src/app/models/Configurations/Languages';
import { ApiService } from '../api/api.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private sessionService: SessionService,
    private api: ApiService,) {
  }

  async setLanguage(languageCode: string): Promise<boolean> {
    try {
      const r = await this.api.put<boolean>('/v1/company/language', { languageCode });
      if (r.success) {
        this.sessionService.changeLanguageDetails(languageCode);
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async setCurrency(currencyCode: string): Promise<boolean> {
    try {
      const r = await this.api.put<boolean>('/v1/company/currency', { currencyCode });
      if (r.success) {
        this.sessionService.changeCurrencyDetails(currencyCode);
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }

  async getCompanyTrialAndStatus(companyId: number): Promise<{ statusId: number, trialPeriodEnd?: string }> {
    try {
      const r = await this.api.get<{ statusId: number, trialPeriodEnd?: string }>(`/v1/company/${companyId}/status`);
      if (r.success) {
        return r.data;
      }
      throw (r.message);
    } catch (err) {
      throw (err);
    }
  }
}
